export const CONFIRMATION_MODAL_TYPES = {
  DELETE: "DELETE",
  CHANGE_STATUS: "CHANGE_STATUS",
  EXPORT: "EXPORT",
  IMPORT: "IMPORT",
  EXPORT_ZIP: "EXPORT_ZIP",

  // Support Ticket
  MARK_UNREAD: "MARK_UNREAD",
  REOPEN_TICKET: "REOPEN_TICKET",

  // JM Interaective Featued
  CHANGE_FEATURE_STATUS: "CHANGE_FEATURE_STATUS",
};
